const initialState = {
  id: '',
  file: '',
  status: '',
  one_time_file: '',
  filename: '',
  size: '',
  display_name: '',
  area: '',
  error: {
    main: ''
  }
}

export default function main(state = initialState, action){
  switch(action.type) {
  case 'SET_STATE_USER_PHOTO':
    return Object.assign({}, state, action.params)
  default:
    return state
  }
}
